import { create } from "zustand";

import { queryClient } from "@/shared/api/query-client";
import { STORAGE_KEYS } from "@/shared/constants/storage-keys";
import { cookie } from "@/shared/lib/cookie";
import { notifyExtensionTokenCleared } from "@/shared/lib/extension-bridge";
import { useUserInfoStore } from "@/shared/store/user-info-store";

import { authQueryKeys } from "./query-options";

interface UserState {
  token: string | null;
  actions: {
    setToken: (token: string) => void;
    logout: () => void;
  };
}

const useUserStore = create<UserState>((set) => ({
  token: (cookie.get(STORAGE_KEYS.authToken) as string) || null,
  actions: {
    setToken: (token: string) => {
      set({ token });
      cookie.set(STORAGE_KEYS.authToken, token);
      void queryClient.invalidateQueries({ queryKey: authQueryKeys.userInfo });
    },
    logout: () => {
      set({ token: null });
      cookie.remove(STORAGE_KEYS.authToken);
      notifyExtensionTokenCleared();
      useUserInfoStore.getState().setUserInfo(null);
      queryClient.removeQueries({ queryKey: authQueryKeys.userInfo });
    },
  },
}));

export const useToken = () => useUserStore((state) => state.token);
export const useUserActions = () => useUserStore((state) => state.actions);

export default useUserStore;
